/**
 * Colunas pre-definidas disponiveis para selecao
 */
export const PREDEFINED_COLUMNS = {
    // Identificacao
    itemId: {
        key: 'itemId',
        label: 'MLB',
        description: 'Codigo do anuncio no Mercado Livre',
        category: 'identification',
        sortable: true,
        align: 'left',
        width: 120,
    },
    title: {
        key: 'title',
        label: 'Anuncio',
        description: 'Nome do anuncio no Mercado Livre',
        category: 'identification',
        sortable: true,
        align: 'left',
        width: 250,
    },
    inventoryId: {
        key: 'inventoryId',
        label: 'ID do Inventario',
        description: 'ID da variacao/inventario do anuncio',
        category: 'identification',
        sortable: true,
        align: 'left',
        width: 150,
    },
    sku: {
        key: 'sku',
        label: 'SKU',
        description: 'SKU do produto (codigo do Bling)',
        category: 'identification',
        sortable: true,
        align: 'left',
        width: 150,
    },
    brand: {
        key: 'brand',
        label: 'Marca',
        description: 'Marca do produto no Bling',
        category: 'identification',
        sortable: true,
        align: 'left',
        width: 140,
    },

    // Dados de Estoque
    blingStock: {
        key: 'blingStock',
        label: 'Estoque Bling',
        description: 'Quantidade disponivel no estoque do Bling',
        category: 'stock',
        sortable: true,
        align: 'center',
        width: 120,
        format: 'stock',
    },
    mlStock: {
        key: 'mlStock',
        label: 'Estoque ML',
        description: 'Quantidade total no Mercado Livre',
        category: 'stock',
        sortable: true,
        align: 'center',
        width: 120,
        format: 'stock',
    },
    mlStockAvailable: {
        key: 'mlStockAvailable',
        label: 'Disponivel ML',
        description: 'Quantidade disponivel no Mercado Livre',
        category: 'stock',
        sortable: true,
        align: 'center',
        width: 120,
        format: 'stock',
    },
    mlStockNotAvailable: {
        key: 'mlStockNotAvailable',
        label: 'Nao Disponivel ML',
        description: 'Quantidade nao disponivel no Mercado Livre',
        category: 'stock',
        sortable: true,
        align: 'center',
        width: 140,
        format: 'stock',
    },

    // Dados do Bling
    blingPrice: {
        key: 'blingPrice',
        label: 'Preco',
        description: 'Preco de venda no Bling',
        category: 'bling',
        sortable: true,
        align: 'center',
        width: 120,
        format: 'currency',
    },
    blingCostPrice: {
        key: 'blingCostPrice',
        label: 'Custo',
        description: 'Preco de custo no Bling',
        category: 'bling',
        sortable: true,
        align: 'center',
        width: 120,
        format: 'currency',
    },
    blingMargin: {
        key: 'blingMargin',
        label: 'Margem',
        description: 'Margem de lucro (baseado no preco ML e custo Bling)',
        category: 'bling',
        sortable: true,
        align: 'center',
        width: 120,
        format: 'percentage',
    },

    // Periodos diarios
    today: {
        key: 'today',
        label: 'Hoje',
        description: 'Vendas do dia atual',
        category: 'daily',
        sortable: true,
        align: 'center',
        width: 80,
    },
    yesterday: {
        key: 'yesterday',
        label: 'Ontem',
        description: 'Vendas de 1 dia atras',
        category: 'daily',
        sortable: true,
        align: 'center',
        width: 80,
    },
    day2: {
        key: 'day2',
        label: '-2d',
        description: 'Vendas de 2 dias atras',
        category: 'daily',
        sortable: true,
        align: 'center',
        width: 80,
    },
    day3: {
        key: 'day3',
        label: '-3d',
        description: 'Vendas de 3 dias atras',
        category: 'daily',
        sortable: true,
        align: 'center',
        width: 80,
    },

    // Agregacoes
    last3d: {
        key: 'last3d',
        label: 'Ult. 3d',
        description: 'Total dos ultimos 3 dias',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 96,
    },
    last5d: {
        key: 'last5d',
        label: 'Ult. 5d',
        description: 'Total dos ultimos 5 dias',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 96,
    },
    last7d: {
        key: 'last7d',
        label: 'Ult. 7d',
        description: 'Total dos ultimos 7 dias',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 96,
    },
    last15d: {
        key: 'last15d',
        label: 'Ult. 15d',
        description: 'Total dos ultimos 15 dias',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 96,
    },
    last30d: {
        key: 'last30d',
        label: 'Ult. 30d',
        description: 'Total dos ultimos 30 dias',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 96,
    },
    last60d: {
        key: 'last60d',
        label: 'Ult. 60d',
        description: 'Total dos ultimos 60 dias',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 96,
    },
    last90d: {
        key: 'last90d',
        label: 'Ult. 90d',
        description: 'Total dos ultimos 90 dias',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 96,
    },
    last180d: {
        key: 'last180d',
        label: 'Ult. 6m',
        description: 'Total dos ultimos 6 meses (180 dias)',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 112,
    },
    last365d: {
        key: 'last365d',
        label: 'Ult. 12m',
        description: 'Total dos ultimos 12 meses (365 dias)',
        category: 'aggregation',
        sortable: true,
        align: 'center',
        width: 112,
    },

    // Analise
    bestDay: {
        key: 'bestDay',
        label: 'Melhor Dia',
        description: 'Data e quantidade do melhor dia de vendas',
        category: 'analysis',
        sortable: true,
        align: 'center',
        width: 128,
    },
    average: {
        key: 'average',
        label: 'Media',
        description: 'Media de vendas por dia',
        category: 'analysis',
        sortable: true,
        align: 'center',
        width: 80,
    },
    salesForecast: {
        key: 'salesForecast',
        label: 'Previsao de Vendas',
        description: 'Formula: (melhor dia ultimos 7d * 7) + (media ultimos 7d * 15)',
        category: 'analysis',
        sortable: true,
        align: 'center',
        width: 150,
    },
};

/**
 * Categorias de colunas para organizacao na UI
 */
export const COLUMN_CATEGORIES = {
    identification: { label: 'Identificacao', order: 1 },
    stock: { label: 'Estoque', order: 2 },
    bling: { label: 'Bling', order: 3 },
    daily: { label: 'Periodos Diarios', order: 4 },
    aggregation: { label: 'Agregacoes', order: 5 },
    analysis: { label: 'Analise', order: 6 },
};

/**
 * Presets do sistema (nao podem ser editados ou excluidos)
 */
export const SYSTEM_PRESETS = [
    {
        id: 'daily-view',
        name: 'Visao Diaria',
        type: 'system',
        columns: [
            { id: 'col-itemId', type: 'predefined', ...PREDEFINED_COLUMNS.itemId },
            { id: 'col-title', type: 'predefined', ...PREDEFINED_COLUMNS.title },
            { id: 'col-sku', type: 'predefined', ...PREDEFINED_COLUMNS.sku },
            { id: 'col-brand', type: 'predefined', ...PREDEFINED_COLUMNS.brand },
            { id: 'col-blingStock', type: 'predefined', ...PREDEFINED_COLUMNS.blingStock },
            { id: 'col-mlStock', type: 'predefined', ...PREDEFINED_COLUMNS.mlStock },
            { id: 'col-today', type: 'predefined', ...PREDEFINED_COLUMNS.today },
            { id: 'col-yesterday', type: 'predefined', ...PREDEFINED_COLUMNS.yesterday },
            { id: 'col-last3d', type: 'predefined', ...PREDEFINED_COLUMNS.last3d },
            { id: 'col-last5d', type: 'predefined', ...PREDEFINED_COLUMNS.last5d },
            { id: 'col-last7d', type: 'predefined', ...PREDEFINED_COLUMNS.last7d },
            { id: 'col-average', type: 'predefined', ...PREDEFINED_COLUMNS.average },
            { id: 'col-bestDay', type: 'predefined', ...PREDEFINED_COLUMNS.bestDay },
            { id: 'col-salesForecast', type: 'predefined', ...PREDEFINED_COLUMNS.salesForecast },
        ],
        createdAt: new Date('2024-01-01'),
        updatedAt: new Date('2024-01-01'),
    },
    {
        id: 'weekly-view',
        name: 'Visao Semanal',
        type: 'system',
        columns: [
            { id: 'col-title', type: 'predefined', ...PREDEFINED_COLUMNS.title },
            { id: 'col-brand', type: 'predefined', ...PREDEFINED_COLUMNS.brand },
            { id: 'col-today', type: 'predefined', ...PREDEFINED_COLUMNS.today },
            { id: 'col-yesterday', type: 'predefined', ...PREDEFINED_COLUMNS.yesterday },
            { id: 'col-last3d', type: 'predefined', ...PREDEFINED_COLUMNS.last3d },
            { id: 'col-last5d', type: 'predefined', ...PREDEFINED_COLUMNS.last5d },
            { id: 'col-last7d', type: 'predefined', ...PREDEFINED_COLUMNS.last7d },
            {
                id: 'col-week-ago',
                type: 'custom',
                name: 'Semana Passada',
                expression: 'WEEK_AGO()',
                sortable: true,
                align: 'center',
                width: 120,
                format: 'number',
            },
            {
                id: 'col-weekly-growth',
                type: 'custom',
                name: 'Crescimento Semanal',
                expression: 'GROWTH(LAST_N_DAYS(7), WEEK_AGO())',
                sortable: true,
                align: 'center',
                width: 140,
                format: 'percentage',
            },
        ],
        createdAt: new Date('2024-01-01'),
        updatedAt: new Date('2024-01-01'),
    },
    {
        id: 'monthly-comparison',
        name: 'Comparativo Mensal',
        type: 'system',
        columns: [
            { id: 'col-title', type: 'predefined', ...PREDEFINED_COLUMNS.title },
            { id: 'col-brand', type: 'predefined', ...PREDEFINED_COLUMNS.brand },
            { id: 'col-last7d', type: 'predefined', ...PREDEFINED_COLUMNS.last7d },
            { id: 'col-last15d', type: 'predefined', ...PREDEFINED_COLUMNS.last15d },
            { id: 'col-last30d', type: 'predefined', ...PREDEFINED_COLUMNS.last30d },
            {
                id: 'col-month-ago',
                type: 'custom',
                name: 'Mes Anterior',
                expression: 'MONTH_AGO()',
                sortable: true,
                align: 'center',
                width: 120,
                format: 'number',
            },
            {
                id: 'col-monthly-variance',
                type: 'custom',
                name: 'Variacao Mensal',
                expression: 'PERCENT_CHANGE(LAST_N_DAYS(30), MONTH_AGO())',
                sortable: true,
                align: 'center',
                width: 140,
                format: 'percentage',
            },
            { id: 'col-average', type: 'predefined', ...PREDEFINED_COLUMNS.average },
        ],
        createdAt: new Date('2024-01-01'),
        updatedAt: new Date('2024-01-01'),
    },
    {
        id: 'complete-analysis',
        name: 'Analise Completa',
        type: 'system',
        columns: [
            { id: 'col-title', type: 'predefined', ...PREDEFINED_COLUMNS.title },
            { id: 'col-brand', type: 'predefined', ...PREDEFINED_COLUMNS.brand },
            { id: 'col-blingStock', type: 'predefined', ...PREDEFINED_COLUMNS.blingStock },
            { id: 'col-today', type: 'predefined', ...PREDEFINED_COLUMNS.today },
            { id: 'col-yesterday', type: 'predefined', ...PREDEFINED_COLUMNS.yesterday },
            { id: 'col-last7d', type: 'predefined', ...PREDEFINED_COLUMNS.last7d },
            { id: 'col-last30d', type: 'predefined', ...PREDEFINED_COLUMNS.last30d },
            { id: 'col-last90d', type: 'predefined', ...PREDEFINED_COLUMNS.last90d },
            { id: 'col-bestDay', type: 'predefined', ...PREDEFINED_COLUMNS.bestDay },
            { id: 'col-average', type: 'predefined', ...PREDEFINED_COLUMNS.average },
            { id: 'col-salesForecast', type: 'predefined', ...PREDEFINED_COLUMNS.salesForecast },
            {
                id: 'col-trend-30d',
                type: 'custom',
                name: 'Tendencia 30d',
                expression: 'GROWTH(LAST_N_DAYS(30), MONTH_AGO())',
                sortable: true,
                align: 'center',
                width: 120,
                format: 'percentage',
            },
        ],
        createdAt: new Date('2024-01-01'),
        updatedAt: new Date('2024-01-01'),
    },
    {
        id: 'inventory-view',
        name: 'Visao por Inventario',
        type: 'system',
        columns: [
            { id: 'col-itemId', type: 'predefined', ...PREDEFINED_COLUMNS.itemId },
            { id: 'col-title', type: 'predefined', ...PREDEFINED_COLUMNS.title },
            { id: 'col-brand', type: 'predefined', ...PREDEFINED_COLUMNS.brand },
            { id: 'col-inventoryId', type: 'predefined', ...PREDEFINED_COLUMNS.inventoryId },
            { id: 'col-today', type: 'predefined', ...PREDEFINED_COLUMNS.today },
            { id: 'col-yesterday', type: 'predefined', ...PREDEFINED_COLUMNS.yesterday },
            { id: 'col-last7d', type: 'predefined', ...PREDEFINED_COLUMNS.last7d },
            { id: 'col-last30d', type: 'predefined', ...PREDEFINED_COLUMNS.last30d },
            { id: 'col-average', type: 'predefined', ...PREDEFINED_COLUMNS.average },
            { id: 'col-bestDay', type: 'predefined', ...PREDEFINED_COLUMNS.bestDay },
            { id: 'col-salesForecast', type: 'predefined', ...PREDEFINED_COLUMNS.salesForecast },
        ],
        createdAt: new Date('2024-01-01'),
        updatedAt: new Date('2024-01-01'),
    },
];

/**
 * ID do preset padrao
 */
export const DEFAULT_PRESET_ID = 'daily-view';
